export default {
  computed: {
    geolocationIsGranted() {
      return this.$store.getters['geolocation/isGranted'];
    },
    geolocationIsDenied() {
      return this.$store.getters['geolocation/isDenied'];
    },
    geolocationPermissionStatus() {
      return this.$store.getters['geolocation/permissionStatus'];
    },
  },
  methods: {
    getGeolocationPosition() {
      return this.$store.dispatch('geolocation/getCurrentPosition');
    },
  },
};
